export interface RestaurantMenu {
  siteId: string
  menuTypeId: string
  categories: Category[]
}

export interface Category {
  id: string
  name: string
  defaultOpeningHours: RestaurantOpeningHours
  products?: CategoryProduct[] | null
}

export interface CategoryProduct {
  id: string
  translations: Record<string, string>
  name?: string | null
  targets?: string[] | null
  assortment?: string | null
}

export interface RestaurantOpeningHours {
  MON: OpensCloses
  TUE: OpensCloses
  WED: OpensCloses
  THU: OpensCloses
  FRI: OpensCloses
  SAT: OpensCloses
  SUN: OpensCloses
}

export interface OpensCloses {
  opens?: string | null
  closes?: string | null
  schedules?:
    | {
        opens: string
        closes: string
      }[]
    | null
}

export interface RestaurantCategorySchedule {
  id?: string
  startDate: string
  endDate: string
  name: string
  categories: ScheduleCategory[]
}

export interface ScheduleCategory {
  id: string
  name: string
  opens?: string | null
  closes?: string | null
  schedules?:
    | {
        opens: string
        closes: string
      }[]
    | null
}

export interface OpeningHoursPeriod {
  periodId: string
  categoryId: string
  periodName: string
  startDate: string
  endDate: string
  openingHours: RestaurantOpeningHours
}

export type ProductModifier = {
  productId: string
  name: string | null
  type: string
  available: boolean
}

export type ProductAvailability = {
  productId: string
  name?: string | null
  ean?: string | null
  available: boolean
  status?: string | null
  modifiers?: ProductModifier[] | null
}

export type ProductAvailabilityCategory = {
  name: string
  products?: ProductAvailability[] | null
  categories?: ProductAvailabilityCategory[] | null
}

export type ProductAvailabilitiesFormValues = {
  products: Record<string, boolean>
  modifiers: Record<string, boolean>
  filter: string
}

export enum ProductType {
  PRODUCT = 'PRODUCT',
  MODIFIER = 'MODIFIER',
}

export enum ProductStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  DISABLED = 'DISABLED',
  PRICE_MISSING = 'PRICE_MISSING',
  MISSING_IN_ASSORTMENT = 'MISSING_IN_ASSORTMENT',
}

export enum ModifierGroupType {
  DRINK = 'DRINK',
  RECIPE = 'RECIPE',
  OTHER = 'OTHER',
  SALAD_BUFFET = 'SALAD_BUFFET',
  SAUCE = 'SAUCE',
  SIDE_DISH = 'SIDE_DISH',
  PIZZA = 'PIZZA',
  CHOICE_GENERIC = 'CHOICE_GENERIC',
  OPTION = 'OPTION',
  EXTRA = 'EXTRA',
}
